<template>
    <VBtnToggle :class="classList" mandatory v-on="$listeners" @change="emitInput">
        <slot />
    </VBtnToggle>
</template>

<script>
import { USER_INPUT_CLASS } from '../../utils/classNames';

const ELEMENT_CLASS = 'sr-button-group';

export default {
    name: 'SrButtonGroup',
    computed: {
        classList() {
            return [ELEMENT_CLASS, USER_INPUT_CLASS];
        },
    },
    methods: {
        emitInput(event) {
            this.$emit('input', event);
        },
    },
};
</script>
